import React from "react";
import { currentTenant } from "../../tenants";

export const TermsAndConditionsPage: React.FC = () => {
  const TenantTermsAndConditionsPage = currentTenant.pages.TermsAndConditionsPage;

  return <TenantTermsAndConditionsPage />;
};
